import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as as from "pages/dashboard/stats/StatsStyled";
import * as mediaQuery from "components/MediaQuery";

export const Container = styled.div<{ noticeHeight?: number }>`
  width: 100%;
  height: ${({ noticeHeight }) =>
    noticeHeight
      ? `
    calc(100vh - ${noticeHeight + 50}px);
  `
      : `calc(100vh - 50px)`};

  ${mediaQuery.isDefault} {
    display: grid;
    grid-template-columns: 30% 70%;
    ${({ theme }) =>
      theme.value === "light" &&
      `
        background-color: ${COLORS.WHITE};
      `}
  }
  ${mediaQuery.isTablet} {
    display: block;
    ${({ theme }) =>
      theme.value === "light" &&
      `
      background-color: transparent;
      `}
  }

  .border {
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.BORDER};
  }
  section:nth-child(1) {
    grid-row: 1;
  }
  section:nth-child(2) {
    ${mediaQuery.isDefault} {
      height: 100%;
    }
    background-color: ${({ theme }) =>
      theme.value === "light" ? theme.COLORS.PRIMARY3 : "#0e1722"};
    display: flex;
    flex: 1;
    ${mediaQuery.isMobile} {
      border-top: 1px solid ${({ theme }) => theme.COLORS.BORDER};
    }
  }
  ${mediaQuery.isTablet} {
    grid-template-columns: 1fr;
  }
`;
export const Section = styled.section`
  width: 100%;
`;

export const Inner = styled(as.Inner)`
  width: 100%;
  height: 100%;
  ${mediaQuery.isMobile} {
    padding: 50px 20px;
    /* height: 100%; */
    overflow: unset;
  }
`;

export const Title = styled.p`
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid ${COLORS.BUTTONS1};
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-weight: 500;
  font-size: ${calcRem(24)};
`;

export const Info = styled.div`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 20px;
  padding: 60px 0;
  ${mediaQuery.isMobile} {
    padding: 20px 0;
  }
  img {
    width: 50%;
    max-width: 200px;
    transform: translateX(10%);
  }
  > button {
    width: 100%;
    max-width: 300px;
  }
`;

export const Copyright = styled.p`
  text-align: center;
  margin-top: 50px;
  ${mediaQuery.isMobile} {
    margin-top: 20px;
  }
  color: ${COLORS.BUTTONS1};
  font-size: ${calcRem(15)};
  .button-wrapper {
    ${FLEX.FlexCenterCenter};
    gap: 10px;
    flex-direction: column;
    ${mediaQuery.isMobile} {
      gap: 5px;
    }
  }
`;

export const ListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ListItem = styled.li`
  border-bottom: 1px solid ${COLORS.BUTTONS1};
  padding: 20px 0;
  ${FLEX.FlexBetweenCenter};

  > div {
    flex: 4;
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${mediaQuery.isMobile} {
    flex-direction: column;
    ${FLEX.FlexStartStart};
    gap: 6px;
    padding: 10px 0;
  }
`;

export const ButtonWrapper = styled.span`
  ${FLEX.FlexEndCenter};
  gap: 15px;
  flex: 1;
`;

export const PageWrapper = styled.div`
  /* padding: 50px 0; */
  width: 100%;

  .pagination-component {
    > ul {
      width: 100%;
      gap: 0;

      /* li {
        flex: 1;
      } */
    }
  }
`;

export const TcWrapper = styled.div`
  /* padding: 50px 0; */
  color: ${({ theme }) => theme.COLORS.WHITE};
  max-height: 500px;
  overflow: auto;

  > div {
    padding-top: 20px;

    > a {
      color: ${COLORS.SELECTED};
    }
  }
`;

export const BigButtonBox = styled.div`
  ${FLEX.FlexEndCenter};
  /* max-width: 160px; */
  flex: 1;

  ${mediaQuery.isMobile} {
    flex-basis: 80px;
  }
`;

export const UploadWrapper = styled.div`
  width: 100%;
  padding: 20px 0;
  display: inline-flex;
`;

export const TaWrapper = styled.div`
  width: 100%;

  textarea {
    width: 100%;
    height: 250px;
  }
`;

export const VersionInfo = styled.ul`
  ${FLEX.FlexCenterCenter};
  gap: 10px;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 300px;
  p {
    color: ${COLORS.BUTTONS1};
    font-size: ${calcRem(14)};
    padding-bottom: 10px;
  }
  button {
    ${FLEX.FlexStartCenter};
    gap: 10px;
    padding: 15px 20px;
    border-radius: 3px;
    font-size: ${calcRem(15)};
    border: 1px solid
      ${({ theme }) =>
        theme.value === "light"
          ? `${COLORS.BUTTONS1}80`
          : theme.COLORS.LIGHTGRAYBORDER};
    background-color: ${({ theme }) => theme.COLORS.BORDER}09;
    color: ${(props) =>
      props.theme.value === "light" ? COLORS.BUTTONS1 : "#b7c0d7"};
    width: 100%;
    cursor: pointer;
    svg {
      color: ${({ theme }) => theme.COLORS.COMPANY};
    }
    path {
      stroke: ${({ theme }) => theme.COLORS.COMPANY} !important;
    }
  }
`;
